import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SECTIONS = {
  ko: [
    {
      title: "1. 수집하는 개인정보 항목",
      content: `(주)코리아트래블스토어2는 서비스 제공을 위해 아래와 같은 개인정보를 수집합니다.

■ 회원가입 시
- 필수: 이메일 주소, 비밀번호

■ 투어 예약 시
- 필수: 이메일 주소, 예약 정보(투어명, 날짜, 인원)

■ 결제 시
- 필수: 결제 수단 정보 (PG사를 통해 처리되며 회사는 카드 정보를 직접 저장하지 않습니다)

■ 서비스 이용 과정에서 자동 수집
- 쿠키, 서비스 이용 기록, 접속 로그`,
    },
    {
      title: "2. 개인정보 수집 및 이용 목적",
      content: `① 회원 관리: 회원제 서비스 이용, 본인 확인, 이메일 인증
② 서비스 제공: 투어 예약 처리, 예약 확인 안내
③ 결제 처리: 요금 결제 및 환불 처리
④ 고객 지원: 불만 처리, 분쟁 조정
⑤ 서비스 개선: 서비스 이용 통계 분석`,
    },
    {
      title: "3. 개인정보 보유 및 이용 기간",
      content: `① 회원 탈퇴 시까지 보유하며, 탈퇴 후 즉시 파기합니다.
② 단, 관련 법령에 의해 보존할 필요가 있는 경우 아래 기간 동안 보관합니다.

- 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)
- 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)
- 접속 로그: 3개월 (통신비밀보호법)`,
    },
    {
      title: "4. 개인정보 제3자 제공",
      content: `회사는 이용자의 개인정보를 원칙적으로 제3자에게 제공하지 않습니다.
다만, 아래의 경우에는 예외로 합니다.

① 이용자가 사전에 동의한 경우
② 법령의 규정에 의거하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우`,
    },
    {
      title: "5. 개인정보 처리 위탁",
      content: `회사는 서비스 제공을 위해 아래와 같이 개인정보 처리를 위탁합니다.

■ 토스페이먼츠 (주)
- 위탁 업무: 결제 처리
- 보유 기간: 결제 완료 후 5년

위탁 업체는 위탁 업무 수행 목적 외 개인정보를 처리하지 않습니다.`,
    },
    {
      title: "6. 이용자의 권리와 행사 방법",
      content: `이용자는 언제든지 아래의 권리를 행사할 수 있습니다.

① 개인정보 열람 요청
② 개인정보 정정·삭제 요청
③ 개인정보 처리 정지 요청
④ 회원 탈퇴 (서비스 내 탈퇴 기능 또는 이메일 요청)

요청은 help@onedaykorea.co.kr로 이메일 문의 시 지체 없이 처리합니다.`,
    },
    {
      title: "7. 개인정보 보호를 위한 기술적·관리적 조치",
      content: `① 비밀번호 암호화 저장 (bcrypt)
② HTTPS 암호화 통신
③ 접근 권한 최소화 및 관리
④ 개인정보 취급자 최소화`,
    },
    {
      title: "8. 쿠키 사용",
      content: `회사는 이용자에게 개인화된 서비스를 제공하기 위해 쿠키를 사용할 수 있습니다.
이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으나, 일부 서비스 이용에 제한이 생길 수 있습니다.`,
    },
    {
      title: "9. 개인정보 보호책임자",
      content: `개인정보 관련 문의, 불만, 피해 구제 등에 관한 사항은 아래 담당자에게 연락해 주세요.

- 이메일: help@onedaykorea.co.kr`,
    },
    {
      title: "10. 개인정보처리방침 변경",
      content: `이 개인정보처리방침은 시행일로부터 적용되며, 변경 시 시행 7일 전부터 공지사항을 통해 고지합니다.`,
    },
  ],
  en: [
    {
      title: "1. Personal Information Collected",
      content: `The Company collects the following personal information to provide its services.

■ Upon membership registration
- Required: Email address, password

■ Upon tour reservation
- Required: Email address, reservation details (tour name, date, number of persons)

■ Upon payment
- Required: Payment method information (processed through PG provider; the Company does not directly store card information)

■ Automatically collected during service use
- IP address, cookies, service usage records, access logs`,
    },
    {
      title: "2. Purpose of Collection and Use",
      content: `① Member management: membership service use, identity verification, email authentication
② Service provision: tour reservation processing, reservation confirmation
③ Payment processing: fee payment and refund processing
④ Customer support: complaint handling, dispute resolution
⑤ Service improvement: statistical analysis of service usage`,
    },
    {
      title: "3. Retention and Use Period",
      content: `① Personal information is retained until membership withdrawal and immediately destroyed thereafter.
② However, if retention is required by relevant laws, information is kept for the following periods:

- Records on contracts or withdrawal of offers: 5 years (E-Commerce Act)
- Records on payment and supply of goods: 5 years (E-Commerce Act)
- Records on consumer complaints or disputes: 3 years (E-Commerce Act)
- Access logs: 3 months (Protection of Communications Secrets Act)`,
    },
    {
      title: "4. Provision of Personal Information to Third Parties",
      content: `The Company does not provide users' personal information to third parties in principle.
Exceptions include:

① When the user has given prior consent
② When required by law or requested by investigative agencies according to legally prescribed procedures`,
    },
    {
      title: "5. Consignment of Personal Information Processing",
      content: `The Company entrusts personal information processing as follows:

■ Toss Payments, Inc.
- Entrusted work: Payment processing
- Retention period: 5 years after payment completion

Entrusted parties do not process personal information beyond the scope of the entrusted work.`,
    },
    {
      title: "6. User Rights and How to Exercise Them",
      content: `Users may exercise the following rights at any time:

① Request to access personal information
② Request to correct or delete personal information
③ Request to suspend processing of personal information
④ Membership withdrawal (via in-service function or email request)

Requests submitted to help@onedaykorea.co.kr will be processed without delay.`,
    },
    {
      title: "7. Technical and Administrative Measures",
      content: `① Encrypted password storage (bcrypt)
② HTTPS encrypted communication
③ Minimization and management of access rights
④ Minimization of personal information handlers`,
    },
    {
      title: "8. Use of Cookies",
      content: `The Company may use cookies to provide personalized services.
Users may refuse cookie storage through browser settings, but some service features may be restricted as a result.`,
    },
    {
      title: "9. Privacy Officer",
      content: `For inquiries, complaints, or remedies related to personal information, please contact:

- Email: help@onedaykorea.co.kr`,
    },
    {
      title: "10. Changes to Privacy Policy",
      content: `This Privacy Policy applies from the effective date. Any changes will be announced through notices at least 7 days before taking effect.`,
    },
  ],
};

export default function PrivacyPage() {
  const navigate = useNavigate();
  const [lang, setLang] = useState("en");

  const sections = SECTIONS[lang];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 헤더 */}
      <div className="bg-white border-b border-gray-100 sticky top-0 z-10">
        <div className="max-w-screen-md mx-auto px-6 h-[56px] flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            ←
          </button>
          <h1 className="text-[16px] font-bold text-gray-900 flex-1">
            {lang === "ko" ? "개인정보처리방침" : "Privacy Policy"}
          </h1>
          {/* 언어 탭 */}
          <div className="flex bg-gray-100 rounded-full p-0.5 gap-0.5">
            {["ko", "en"].map((l) => (
              <button
                key={l}
                onClick={() => setLang(l)}
                className={[
                  "px-3 py-1 rounded-full text-[12px] font-semibold transition-all",
                  lang === l ? "bg-white text-gray-800 shadow-sm" : "text-gray-400",
                ].join(" ")}
              >
                {l === "ko" ? "KO" : "EN"}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-screen-md mx-auto px-6 py-8">
        <p className="text-[13px] text-gray-400 mb-2">
          {lang === "ko" ? "시행일: 2026년 6월 11일" : "Effective Date: June 11, 2026"}
        </p>
        <p className="text-[14px] text-gray-600 leading-relaxed mb-8">
          {lang === "ko"
            ? "(주)코리아트래블스토어2는 이용자의 개인정보를 소중히 여기며 「개인정보 보호법」 등 관련 법령을 준수합니다."
            : "(주)코리아트래블스토어2 values users' personal information and complies with relevant laws including the Personal Information Protection Act."}
        </p>

        <div className="flex flex-col gap-6">
          {sections.map((section, i) => (
            <div key={i} className="bg-white rounded-[16px] border border-gray-100 p-5">
              <h2 className="text-[15px] font-bold text-gray-900 mb-3">{section.title}</h2>
              <p className="text-[14px] text-gray-600 leading-relaxed whitespace-pre-line">{section.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 p-5 bg-white rounded-[16px] border border-gray-100">
          <p className="text-[13px] font-semibold text-gray-700 mb-1">
            {lang === "ko" ? "개인정보 관련 문의" : "Privacy Inquiries"}
          </p>
          <p className="text-[13px] text-gray-400">help@onedaykorea.co.kr</p>
        </div>
      </div>
    </div>
  );
}